import React from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import DangerousHTMLContainer from 'components/DangerousHTMLContainer';
import { usePortalCode } from 'helpers/portal';

type RouteProps = {
  companyId: UUIDField;
};

function ClientPortal() {
  const { companyId } = useParams<RouteProps>();
  const [searchParams] = useSearchParams();
  let rootId = 'retino-portal';
  const urlParam = Array.from(searchParams.keys()).find((k) => k.startsWith(rootId) && k.endsWith('-url'));
  if (urlParam) {
    rootId = urlParam.substring(0, urlParam.indexOf('-url'));
  }
  const portalCode = usePortalCode(companyId!, window.appState.lang, { rootId });
  return <DangerousHTMLContainer html={portalCode} />;
}

export default ClientPortal;
